/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import gql from "graphql-tag";

export const CONVERSATION_FRAGMENT = gql`
    fragment generalConversationFields on Conversation {
        id
        created_at
        total_messages
        has_read
        last_message_at
        last_message
        to_institution_id
        to_institution {
            id
            name
            logo
        }
        from_institution_id
        from_institution {
            id
            name
            logo
        }
        participants {
            id
            first_name
            last_name
            full_name
        }
        deal {
            id
            name
        }
    }
`;

export const MESSAGE_FRAGMENT = gql`
    fragment generalMessageFields on ConversationMessage {
        id
        message
        user {
            id
            first_name
            last_name
            full_name
            title
        }
        created_at
        last_modified_at
    }
`;

// TS CODE CHANGE: added GetConversationQuery
export const GET_CONVERSATIONS_QUERY = gql`
    query GetConversationQuery {
        conversations {
            ...generalConversationFields
        }
    }
    ${CONVERSATION_FRAGMENT}
`;

export const GET_RECIPIENT_USERS_QUERY = gql`
    query RecipientUsersQuery($institution_id: UUID!) {
        users: recipientUsers(institution_id: $institution_id) {
            id
            title
            purpose_for_using_convergence_v2
            preferences {
                deal_types
                regions
                regions_v2
                countries
                sectors
                sub_sectors
                impact_themes
                impact_objectives
                sdgs
            }
        }
    }
`;
// TS CODE CHANGE added GetMessagesQuery
export const GET_MESSAGES_QUERY = gql`
    query GetMessagesQuery($conversation_id: UUID!) {
        messages(conversation_id: $conversation_id) {
            ...generalMessageFields
        }
    }
    ${MESSAGE_FRAGMENT}
`;

export const UPDATE_HAS_READ_CONVERSATION_FRAGMENT = gql`
    fragment activeConversation on Conversation {
        has_read
    }
`;
